// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".materials-cart-button{position:relative;display:inline-block;width:45px;height:52px;font-size:42px;text-align:center}.materials-cart-button--badge{position:absolute;-webkit-transform:scale(.8);transform:scale(.8);top:28px;left:-6px}", ""]);
// Exports
module.exports = exports;
